<div (click)="openPopOver()">
  <div><ssg-button [disabled]="disabled" [size]="size" [appearance]="appearance" [label]="label" [icon]="icon"></ssg-button></div>
  <ssg-popover *ngIf="openToggle" id="popovercontent" (outsideClick)="close()" (onSelectItem)="close()" (selectContains)="close()">
    <div [id]="name">
      <ng-content select=".menuitem"></ng-content>
    </div>
  </ssg-popover>
</div>
